(function () {
  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    // Section script (defer) runs before swiper-bundle.min.js (defer, end of body).
    // Wait until all deferred scripts have run.
    const onReady = () => {
      if (typeof Swiper !== 'undefined') {
        callback();
        return true;
      }
      return false;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        if (!onReady()) {
          setTimeout(() => onReady(), 0);
        }
      });
    } else if (!onReady()) {
      setTimeout(() => onReady(), 0);
    }
  }

  function getSpaceBetween(el) {
    const raw = getComputedStyle(el).getPropertyValue('--festive-spotlight-slide-gap').trim();
    const value = parseInt(raw, 10);
    return Number.isNaN(value) ? 24 : value;
  }

  function initSpotlightSlider(root) {
    const el = root.querySelector('[data-collection-festive-spotlight]');
    if (!el || el.swiper) return;

    const slides = el.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    const slideCount = slides.length;
    const enableLoop = el.dataset.loop === 'true' && slideCount > 1;

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: getSpaceBetween(el),
      autoHeight: true,
      loop: enableLoop,
      loopedSlides: enableLoop ? slideCount : undefined,
      watchOverflow: true,
      grabCursor: slideCount > 1,
      speed: 600,
      slideToClickedSlide: slideCount > 1,
      observer: true,
      observeParents: true,
      resistanceRatio: 0.85,
    });

    const updateHeight = () => {
      if (swiper && !swiper.destroyed) {
        swiper.update();
        swiper.updateAutoHeight(300);
      }
    };

    el.querySelectorAll('.collection-festive-spotlight__image').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', updateHeight, { once: true });
    });

    window.addEventListener('resize', updateHeight);
  }

  function initAll() {
    document.querySelectorAll('[data-collection-festive-spotlight-root]').forEach(initSpotlightSlider);
  }

  whenSwiperReady(initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector('[data-collection-festive-spotlight-root]') ||
      (event.target.matches?.('[data-collection-festive-spotlight-root]') ? event.target : null);

    if (!root) return;

    whenSwiperReady(() => initSpotlightSlider(root));
  });
})();
